export const SC_PLAN_STATUS = {
  // 进行中、已结算
  WORKING: {
    label: '进行中',
    value: 0
  },
  COMPLETED: {
    label: '已结算',
    value: 1
  }
}

// 结算依据
export const SETTLEMENT_BASIS = {
  PLAN_TON: {
    label: '计划吨位',
    value: 3
  },
  LOADING_TON: {
    label: '装载吨位',
    value: 1
  },
  UNLOADING_TON: {
    label: '卸载吨位',
    value: 2
  },
}
// 结算模式
export const SETTLEMENT_MODE = {
  ALL: {
    label: '无扣减',
    percentage: 0,
    value: 0
  },
  PERCENTAGE_8: {
    label: '千分之八',
    percentage: 0.008,
    value: 8
  },
  PERCENTAGE_5: {
    label: '千分之五',
    percentage: 0.005,
    value: 5
  },
  PERCENTAGE_3: {
    label: '千分之三',
    percentage: 0.003,
    value: 3
  }
}
